import React from "react";
import { useTranslation } from "react-i18next";
import Avatar from 'react-avatar';
import Button from "../../../../../components/Button";
import ElipsisText from "../../../../../components/ElipsisText";
import { Modules, AuthRoutes, RouteParamsTypes } from "../../../../../enums";
import NoPropertyImg from '../../../../../assets/img/custom/no-property.jpeg';

interface PropertiesTabProps {
  properties?: any[];
  view: boolean;
  edit: boolean;
  onAssignPropertiesClick: () => void;
  onRemoveProperty: (id: string) => void;
}

const PropertiesTab: React.FC<PropertiesTabProps> = ({
  properties,
  view,
  edit,
  onAssignPropertiesClick,
  onRemoveProperty,
}) => {
  const { t } = useTranslation();

  const handleViewClick = (id: string) => {
    window.open(`${Modules.resources}${AuthRoutes.properties}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  return (
    <div className="card-body">
      {
        !view && (
          <div className="d-flex justify-content-end mb-4">
            <Button
              className="btn btn-primary"
              icon={<i className="ri-add-line ri-20px me-1"></i>}
              text={t('users.addEdit.pageTexts.assignPropertiesModal.openBtn')}
              onClick={onAssignPropertiesClick}
            />
          </div>
        )
      }

      {!view && properties && properties.length > 0 && <hr className="my-6" />}

      <div className="row g-4">
        {
          view && (!properties || !properties.length)
            ?
            (
              <p className="dataTables_empty text-center">{t("users.addEdit.pageTexts.noPropertyAssigned")}</p>
            )
            :
            (properties || []).map((property: any) => {
              return (
                <div className="col-md-3" key={property.id}>
                  <div className="card">
                    <Avatar className="card-img-top w-100 h-250px" src={property.picture_url || NoPropertyImg} name={property.name} maxInitials={2} />

                    {
                      edit && (
                        <Button
                          icon={<i className="ri-delete-bin-6-line ri-20px text-danger"></i>}
                          className="btn btn-sm position-absolute end-10 top-10 rounded-circle bg-lightest p-2"
                          onClick={() => onRemoveProperty(property.assignment_id)}
                        />
                      )
                    }

                    <div className="card-body">
                      <ElipsisText
                        text={property.name}
                        width="100%"
                        className="h5 card-title text-decoration-underline hyperlink"
                        onClick={() => handleViewClick(property.id)}
                      />
                      <ElipsisText
                        text={property?.city_data?.name ?? '-'}
                        width="100%"
                        className="p card-text"
                      />
                    </div>
                  </div>
                </div>
              )
            })
        }
      </div>
    </div>
  )
};

export default PropertiesTab;
